// extracted by mini-css-extract-plugin
export var customerLogos = "homepageModular-module--customer-logos--fa0c7";
export var videoCallout = "homepageModular-module--video-callout--2c124";